import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

import { FieldMeta } from '@/modules/dynamic-form/models/FieldMeta.model';
import { FieldSchema } from '@/modules/dynamic-form/models/FieldSchema.model';
import { TypeDefinitionList } from '@/modules/dynamic-form/models/TypeDefinition.model';

import { createSimpleFieldDefaultMeta } from './general';

export function createListFieldMeta(
    createFieldMetaFromSchema: (schema: FieldSchema, context?: { requirementType?: TprmRequirementType }) => FieldMeta,
    schema: FieldSchema,
    context?: { requirementType?: TprmRequirementType },
): FieldMeta {
    const meta = createSimpleFieldDefaultMeta(schema);
    const items = createFieldMetaFromSchema(
        { path: `${schema.path}.$item`, type: (schema.type as TypeDefinitionList).elementType } as FieldSchema,
        context,
    );
    return { ...meta, items, defaultValue: [ items.defaultValue ] };
}
